import React, { memo } from 'react';
import { Tooltip } from '../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';

export const InstanceTagsLabel = memo(() => (
    <span>
        Instance Tags{' '}
        <Tooltip
            title={<>A tag consists of a key-value pair.
                Maximum number of tags per resource: 50.
                Maximum key length: 127.
                Maximum value length: 255.
                Tag keys and values are case sensitive.
                Allowed characters are letters,
                spaces and numbers representable in UTF-8,
                plus the following special characters: + - = . _ : / @
            </>}
        >
            <QuestionCircleOutlined />
        </Tooltip>
    </span>
));
